import React from "react";
import styles from "./aboutUsExtra.module.css";

function index({ heroImage, p1, gifSubtitle, qualityWord, mission }) {
  return (
    <div className={styles.heroWrapper}>
      <img src={`${heroImage}`} alt="Fruits" />
      <div className={styles.pWrapper}>
        <div className={styles.headingWrapper}>
          <h2 className={`mainHeading  ${styles.mission}`}>{mission}</h2>
        </div>
        <p className={styles.paragraph}>{p1}</p>
        <p className={styles.subtitle}>{gifSubtitle}</p>
        <div>
          <div>
            {qualityWord.map((item, i) => (
              <p key={i} className={styles.qualityWordsWrapper}>
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
